import { CIScreen } from 'containers/Setting/components/RoleFormModal/customerIntelligence';

// Typed as `CIScreen` for the same reason `permissions/constants.ts` types the overview key: a typo
// is then a compile error rather than a route that silently denies every user. PLA-8828.
export const C360_SCREEN_CUSTOMER_360: CIScreen = 'customer_intelligence.customer360';

// The `:id` segment of `/p/customers/show/:id/customer-360`, and the only thing this feature puts in
// the URL — FR § 15 keeps every other identifier out of it.
export const C360_ROUTE_SEGMENT = 'customer-360';

/* The severities an `Unresolved Issues` row can carry. Closed rather than `string` because the row's
   severity is spelt straight into a copy key — a value the catalogue cannot name renders as the raw
   key, which is exactly how `Low` reached the screen. The catalogue is held to this list by
   `i18n/__tests__/translations.test.ts`. PLA-8844. */
export const C360_ISSUE_SEVERITIES = ['High', 'Medium', 'Low'] as const;

export type Customer360IssueSeverity = (typeof C360_ISSUE_SEVERITIES)[number];
